import { BrowserRouter, Routes, Route } from "react-router";

import Header from './components/Header';
import Map from './components/Map';
import Documents from './components/Documents';
import { UserProvider } from './store/User'

import { ThemeProvider } from '@mui/material/styles';
import { theme } from './theme';
import './App.css';

function App() {

  return (
    <ThemeProvider theme={theme}>
      <BrowserRouter>
        <UserProvider>
          <div className="App">
            <Header />
            <Map />
            {/* <Routes>
              <Route path="/" element={<Map />} />
              <Route path="/documents" element={<Documents />} />
            </Routes> */}
          </div>
        </UserProvider>
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;
